export const PAYMENT_RETURN_URL_KEY = 'paymentReturnUrl'
export const PAYMENT_CREDITS_BEFORE_KEY = 'paymentCreditsBeforeCheckout'
export const PAYMENT_PENDING_PURCHASE_KEY = 'pendingCreditPurchase'

export interface PendingCreditPurchase {
  amount: number
  initiatedAt: string
  returnPath: string
  creditsBeforeCheckout: number
}

export const setPendingCreditPurchase = (purchase: PendingCreditPurchase) => {
  sessionStorage.setItem(PAYMENT_PENDING_PURCHASE_KEY, JSON.stringify(purchase))
}

export const getPendingCreditPurchase = (): PendingCreditPurchase | null => {
  const raw = sessionStorage.getItem(PAYMENT_PENDING_PURCHASE_KEY)
  if (!raw) return null

  try {
    const parsed = JSON.parse(raw) as Partial<PendingCreditPurchase>
    if (
      typeof parsed.amount !== 'number' ||
      typeof parsed.initiatedAt !== 'string' ||
      typeof parsed.returnPath !== 'string' ||
      typeof parsed.creditsBeforeCheckout !== 'number'
    ) {
      return null
    }

    return parsed as PendingCreditPurchase
  } catch {
    return null
  }
}

export const clearPendingCreditPurchase = () => {
  sessionStorage.removeItem(PAYMENT_PENDING_PURCHASE_KEY)
}
